<template>
  <v-container grid-list-md fluid>
    <v-layout align-center justify-space-around wrap>
      <v-flex md12>
        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>Templates</v-toolbar-title>
        </v-toolbar>
      </v-flex>

      <v-flex md12>
        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text color="primary" @click.prevent="osdialog = true;" v-if="aaaaccess(user)">
              <v-icon dark left>create</v-icon>
              New Template
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex md12>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :footer-props="{
              'items-per-page-options': [15, 50, -1]
            }"
            :items="Object.values(allTemplates)"
            :loading="isLoading.templates"
            :search="search"
            :sort-by="'name'"
            :sort-desc="false"
            item-key="name"
            class="elevation-1"
            dense
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.templateid" @click="openTemplateTab(item)" :style="{cursor:'pointer'}">
                  <td><v-icon small>reorder</v-icon></td>
                  <td>{{ smallId(item.templateid) }}</td>
                  <td>{{ deviceTypeToString(item.type) }}</td>
                  <td>{{ item.os }}</td>
                  <td>{{ item.baseimage }}</td>
                  <td>{{ item.owner }}</td>
                  <td>{{ dateToString(item.lastmodified) }}</td>
                  <td >
                    <v-icon small v-if="item.approved">check</v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="osdialog"
      width="500"
    >
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="os"
            :items="['CentOS 7', 'Rocky Linux 8', 'Rocky Linux 9', 'AlmaLinux 9', 'AlmaLinux 10', 'Debian 9 ARMEL', 'Debian 9 ARMHF', 'Debian 9 ARMHF WAGO', 'Debian 11 ARM64', 'Debian 12 ARM64']"
            clearable
            label="OS"
          ></v-autocomplete>
        </v-card-text>
        <v-card-text>
          <v-autocomplete
            v-model="type"
            :items="['PAC', 'SCADA']"
            clearable
            label="Type"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.prevent="osdialog = false">Cancel</v-btn>
          <v-btn color="primary" text @click.prevent="callNewTemplate(); osdialog = false;">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog"
      persistent
      width="500"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTimeout"
      :top="true"
    >
      {{ snackMessage }}
      <v-btn
        text
        @click="snack = false"
      >
        <div class="v-menu__content--active" style="display:none; z-index:1000;"></div>
        Close
      </v-btn>
    </v-snackbar>

  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import libvue from '@/lib/vue.js'

export default {
  mixins: [libvue],
  data () {
    return {
      search: null,
      dialog: false,
      osdialog: false,
      os: null,
      type: null,
      snack: false,
      snackColor: 'primary',
      snackMessage: '',
      snackTimeout: 1000,
      headers: [
        { text: '', value: '' },
        { text: 'ID', value: 'templateid' },
        { text: 'Type', value: 'type' },
        { text: 'OS', value: 'os' },
        { text: 'Base Image', value: 'baseimage' },
        { text: 'Owner', value: 'owner' },
        { text: 'Last Modified', value: 'lastmodified' },
        { text: 'Approved', sortable: true, value: 'approved' }
      ]
    }
  },
  computed: {
    ...mapGetters(['allTemplates', 'user', 'isLoading', 'error']),
  },
  created() {
    this.filterTemplates();
  },
  watch: {
  },
  methods: {
    callNewTemplate() {
      this.dialog = true;
      var devtype = null;
      switch (this.type) {
        case "PAC":
          // eslint-disable-next-line no-undef
          devtype = proto.pb.DeviceType.DEVICEPAC;
          break;
        case "SCADA":
          // eslint-disable-next-line no-undef
          devtype = proto.pb.DeviceType.DEVICESCADA;
          break;
      }
      this.newTemplate({"os": this.os, "type": devtype}).then((v) => {
        this.dialog = false;
        this.snack = false;
        this.openTemplateTab(v);
      }).catch((err) => {
        this.dialog = false;
        this.snack = true;
        this.snackColor = 'error'
        this.snackMessage = this.errToString(err);
      });
    },
    openTemplateTab(v) {
      this.$router.push({ name: 'template-details', params: { TemplateID: v.templateid } });
    },
    ...mapActions(['filterTemplates', 'newTemplate'])
  }
}
</script>
